import HeaderLayout from './HeaderLayout';
import HeaderMenuContextProvider from '@/creditflowresearch/application/SearchHeaderMenu/HeaderMenuContext';
import linksConfig from './linksConfig';

const HeaderContainer = () => (
  <HeaderMenuContextProvider>
    <HeaderLayout
      linksConfig={ linksConfig }
    />
  </HeaderMenuContextProvider>
);

export default HeaderContainer;
